import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useDispatch, useSelector } from "react-redux";
import { authenticateUser, formatError, formatSuccess } from "../../../core/data/redux/service/AuthService";
import apiService from "../../../server";
import { RootState } from "../../../core/data/redux/store";
import { MD5 } from "crypto-js";
import { fetchLoggedInUser } from "../../../core/data/redux/actions/UserActions";
import { Logout } from "../../../core/data/redux/actions/AuthActions";

const ResetPassword2 = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const currentUser = useSelector((state: RootState) => state.user.currentUser);

  useEffect(() => {
    dispatch(fetchLoggedInUser())
  }, [])

  const dispatch = useDispatch<any>();

  // const [data, setData] = useState({
  //   mobileNumber: "",
  //   newPwd: "",
  //   confirmPwd: "",
  // });


  // const navigationPath = () => {
  //   navigation(routes.resetPasswordSuccess2);
  // };
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const [password, setPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordResponce, setPasswordResponce] = useState({
    passwordResponceText: "Use 8 or more characters with a mix of letters, numbers, and symbols.",
    passwordResponceKey: "",
  });
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [error, setError] = useState({
    oldPassword: "",
    password: "",
    confirmPassword: "",
  });
  const togglePasswordVisibility = (field: "password" | "confirmPassword") => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const onChangePassword = (password: string) => {
    setPassword(password);
    if (password.match(/^$|\s+/)) {
      setPasswordResponce({
        passwordResponceText: "Use 8 or more characters with a mix of letters, numbers & symbols",
        passwordResponceKey: "",
      });
    } else if (password.length === 0) {
      setPasswordResponce({
        passwordResponceText: "",
        passwordResponceKey: "",
      });
    } else if (password.length < 8) {
      setPasswordResponce({
        passwordResponceText: "Weak. Must contain at least 8 characters",
        passwordResponceKey: "0",
      });
    } else if (password.length > 15) {
      setPasswordResponce({
        passwordResponceText: "Too Much. Must be at most 15 characters",
        passwordResponceKey: "0",
      });
    }

    else if (
      password.search(/[a-z]/) < 0 ||
      password.search(/[A-Z]/) < 0 ||
      password.search(/[0-9]/) < 0
    ) {
      setPasswordResponce({
        passwordResponceText: "Average. Must contain at least 1 upper case and number",
        passwordResponceKey: "1",
      });
    } else if (password.search(/(?=.*?[#?!@$%^&*-])/) < 0) {
      setPasswordResponce({
        passwordResponceText: "Almost. Must contain a special symbol",
        passwordResponceKey: "2",
      });
    } else {
      setPasswordResponce({
        passwordResponceText: "Awesome! You have a secure password.",
        passwordResponceKey: "3",
      });
    }
  };

  const resetpwd = async (e: any) => {
    if (validateData()) {
      const encKey = await MD5(password).toString();
      const encold = await MD5(oldPassword).toString();
      try {
        const res = await apiService.put("/api/user/change-pwd", {
          mobileNumber: currentUser.phoneNumber,
          newPwd: encKey,
          oldPwd: encold,
          otp,
        });
        if (res) {
          dispatch(Logout(navigate));
          formatSuccess(res.data);
        }
      } catch (error: any) {
        formatError(error.response.data);
      }
    }
  };
  const handleOtpChange = (e: any) => {
    setOtp(e.target.value);
  };

  const sendOtp = async (e: any) => {
    if (validateData()) {
      try {
        const res = await authenticateUser(currentUser.phoneNumber);
        if (res) {
          setIsOtpSent(true);
          formatSuccess(res.data?.message);
        }
      } catch (error: any) {
        formatError(error.response.data?.message);
      }
    }
  };


  const validateData = () => {
    let isValid = true;
    let newErrors = { oldPassword: "", password: "", confirmPassword: "" };

    if (!oldPassword) {
      newErrors.oldPassword = "Old Password is required.";
      isValid = false;
    }
    if (confirmPassword !== password) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }
    if (passwordResponce.passwordResponceKey < "3") {
      // newErrors.password = "Password must be between 8 to 15 characters long and follow policy.";
      isValid = false;
    }


    setError(newErrors);
    return isValid;
  };
  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-5">
            <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent">
              <div>
                <ImageWithBasePath src="assets/img/bg/authentication-bg-06.svg" alt="Img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-md-7 mx-auto vh-100">
                <form className="vh-100">
                  <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                    <div className=" mx-auto mb-5 text-center">
                      <ImageWithBasePath
                        src="assets/tl-full.png"
                        className="img-fluid"
                        alt="Logo"
                      />
                    </div>
                    <div className="">
                      <div className="text-center mb-3">
                        <h2 className="mb-2">Reset Password</h2>
                        <p className="mb-0">
                          {/* Your new password must be different from previous used
                          passwords. */}
                        </p>
                      </div>
                      <div>

                        {!isOtpSent && (
                          <>
                            <div className="input-block mb-3">
                              <div className="mb-3">
                                <label className="form-label">Old Password</label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    name="oldPassword"
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                    className="form-control border-end-0"
                                    required
                                  />
                                  <span className="input-group-text border-start-0">
                                    <i className="ti ti-mail" />
                                  </span>
                                </div>
                                {error.oldPassword && (
                                  <p className="text-danger">{error.oldPassword}</p>
                                )}
                              </div>


                              <div className="mb-3">
                                <label className="form-label">New Password</label>
                                <div className="pass-group" id="passwordInput">
                                  <input
                                    type={passwordVisibility.password ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => onChangePassword(e.target.value)}
                                    className="form-control pass-input"
                                    placeholder="Enter your password"
                                  />
                                  <span
                                    className={`ti toggle-passwords ${passwordVisibility.password ? "ti-eye" : "ti-eye-off"
                                      }`}
                                    onClick={() => togglePasswordVisibility("password")}
                                    style={{ cursor: "pointer" }}
                                  ></span>
                                </div>
                              </div>
                              {error.password && (
                                <p className="text-danger">{error.password}</p>
                              )}
                              <div
                                className={`password-strength d-flex ${passwordResponce.passwordResponceKey === "0"
                                  ? "poor-active"
                                  : passwordResponce.passwordResponceKey === "1"
                                    ? "avg-active"
                                    : passwordResponce.passwordResponceKey === "2"
                                      ? "strong-active"
                                      : passwordResponce.passwordResponceKey === "3"
                                        ? "heavy-active"
                                        : ""
                                  }`}
                                id="passwordStrength"
                              >
                                <span id="poor" className="active" />
                                <span id="weak" className="active" />
                                <span id="strong" className="active" />
                                <span id="heavy" className="active" />
                              </div>
                            </div>
                            <p className="fs-12 text-danger">{passwordResponce.passwordResponceText}</p>
                            <div className="mb-3">
                              <label className="form-label">Confirm Password</label>
                              <div className="pass-group">
                                <input
                                  type={
                                    passwordVisibility.confirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className="pass-input form-control"
                                  value={confirmPassword}
                                  onChange={(e) => setConfirmPassword(e.target.value)}

                                />
                                <span
                                  className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                    ? "ti-eye"
                                    : "ti-eye-off"
                                    }`}
                                  onClick={() =>
                                    togglePasswordVisibility("confirmPassword")
                                  }
                                ></span>
                              </div>
                              {error.confirmPassword && (
                                <p className="text-danger">{error.confirmPassword}</p>
                              )}
                            </div>
                          </>
                        )}

                        {isOtpSent && (
                          <div className="mb-3">
                            <label className="form-label">Enter OTP</label>
                            <div className="input-group">
                              <input
                                type="text"
                                name="otp"
                                value={otp}
                                onChange={handleOtpChange}
                                className="form-control border-end-0"
                                required
                              />
                              <span className="input-group-text border-start-0">
                                <i className="ti ti-key" />
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mb-3 d-flex justify-space-between">

                          {!isOtpSent && (
                            <button type="button" onClick={sendOtp} className="btn btn-primary w-100">
                              Send OTP
                            </button>)}

                          {isOtpSent && (
                            <div className="d-flex">
                              <button
                                type="button"
                                className="btn btn-primary w-50 me-1"
                                onClick={resetpwd}
                              >
                                Reset Password
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger w-50 ms-1"
                                onClick={sendOtp}
                              >
                                ReSend OTP
                              </button>
                            </div>
                          )}
                        </div>
                        <button type="button" onClick={() => dispatch(Logout(navigate))} className="btn btn-primary w-100 ">
                          Go Back
                        </button>
                      </div>
                    </div>
                    <div className="mt-5 pb-4 text-center">
                      <p className="mb-0 text-gray-9">Copyright © 2024 - HKCL</p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default ResetPassword2;
